// Iter-87: reusable country helpers used by Client, Mission, Settings and future search bar.
//
// The 3 priority countries are pinned at the top of every picker; the rest follows
// (alphabetical by `name`). Afghanistan (AF) is excluded per BAIM policy.
// `flagEmoji(iso2)` converts any ISO-2 country code into its regional-indicator flag
// emoji so we can replace the generic 🌍 globe everywhere.

export const PRIORITY_COUNTRIES = ["MA", "SN", "FR"];
export const HIDDEN_COUNTRIES = new Set(["AF"]);

/**
 * Convert an ISO-3166 alpha-2 country code into its 2-codepoint flag emoji.
 *   flagEmoji("MA") === "🇲🇦"
 *   flagEmoji("")   === ""
 */
export function flagEmoji(code) {
  if (!code || typeof code !== "string" || code.length !== 2) return "";
  const base = 127397; // 'A'.charCodeAt(0) (65) - 0x1F1E6 (127462)  →  offset
  const chars = code.toUpperCase().split("").map((c) => String.fromCodePoint(c.charCodeAt(0) + base));
  return chars.join("");
}

/**
 * Sort a list of `{code, name}` countries so that PRIORITY_COUNTRIES come first (in
 * declared order), followed by the rest alphabetically by `name`. HIDDEN_COUNTRIES
 * (currently just AF) are stripped.
 */
export function sortCountriesByPriority(countries) {
  const byCode = Object.fromEntries((countries || []).map((c) => [c.code, c]));
  const priority = PRIORITY_COUNTRIES.map((code) => byCode[code]).filter(Boolean);
  const rest = (countries || [])
    .filter((c) => !PRIORITY_COUNTRIES.includes(c.code) && !HIDDEN_COUNTRIES.has(c.code))
    .sort((a, b) => (a.name || "").localeCompare(b.name || ""));
  return [...priority, ...rest];
}
